<template>
    <div v-if="visible" :class="classes">
        <slot></slot>
    </div>
</template>

<script setup>
import { ref, computed, inject, watch } from 'vue'

const props = defineProps({
    title: String,
    id: {
        type: [String, Number],
        default: null
    },
    visible: {
        type: Boolean,
        default: true
    },
    disabled: {
        type: Boolean,
        default: false
    }
})

const identifier = ref(null)
const selectedTab = ref(0)
const setTabVisibility = inject('setTabVisibility')
const setTabDisabled = inject('setTabDisabled')
// Inject the update title function
const updateTabTitle = inject('updateTabTitle', null)

const classes = computed(() => ({
    'zs-tab-content': true,
    'active': selectedTab.value === identifier.value
}))

const setId = (val) => {
    identifier.value = props.id ? props.id : val
}

const selectTab = (index) => {
    selectedTab.value = index
}

// Watch for changes to the title prop
watch(() => props.title, (newTitle) => {
    if (updateTabTitle && identifier.value !== null) {
        updateTabTitle(identifier.value, newTitle)
    }
}, { immediate: false })

watch(() => props.visible, (val) => {
    setTabVisibility(identifier.value, val)
})

watch(() => props.disabled, (val) => {
    setTabDisabled(identifier.value, val)
})

watch(identifier, (val) => {
    setTabVisibility(val, props.visible)
    setTabDisabled(val, props.disabled)
    // When identifier is set, also update the title
    if (updateTabTitle && val !== null && props.title) {
        updateTabTitle(val, props.title)
    }
})

defineExpose({
    identifier,
    title: props.title,
    setId,
    selectTab
})
</script>

<style >
:root {
    --zs-tab-content-display-default: none;
    --zs-tab-content-margin-bottom: 1em;
    --zs-tab-content-padding: 1em;
    --zs-tab-content-active-display: block;
}

.zs-tab-content {
    display: var(--zs-tab-content-display-default);
    margin-bottom: var(--zs-tab-content-margin-bottom);
    padding: var(--zs-tab-content-padding);
}

.zs-tab-content.active {
    display: var(--zs-tab-content-active-display);
}
</style>
